import { createSlice } from "@reduxjs/toolkit";
import { getProductionBatchList } from "../../reduxApi/admin/ProductionBatchReduxApi";

const productionBatchSlice = createSlice({
    name: 'productionBatch',
    initialState: {
        status: 'idel',
        isFiltered: false,
        productionBatch: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteProductionBatchAction: (state, action) => {
            console.log("action.payload", action.payload);
            console.log("productionBatch value:", state.productionBatch);
            console.log("is array:", Array.isArray(state.productionBatch));
            action.payload.forEach((id) => {
                const index = Array(state.productionBatch)?.findIndex(
                    (item) => item.ROWID === id
                );

                console.log("index", index);

                if (index !== -1) {
                    state.productionBatch.splice(index, 1);
                }
            });
        },

        updateProductionBatchAction: (state, action) => {
            const index = state.productionBatch.findIndex((item) => item.ROWID === action.payload.ROWID);
            if (index !== -1) {
                state.productionBatch.splice(index, 1, { productionBatch: action.payload });
            }
        },
        addProductionBatchAction: (state, action) => {
            console.log("action--->", action.payload);
            state.productionBatch.push(action.payload)
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getProductionBatchList.pending, (state, action) => {
            state.status = 'pending';
        })
            .addCase(getProductionBatchList.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.productionBatch = action.payload?.data || action.payload;
            })
            .addCase(getProductionBatchList.rejected, (state, action) => {
                state.status = 'rejected';
            });
    }
});

export const {
    deleteProductionBatchAction,
    updateProductionBatchAction,
    addProductionBatchAction,
    setFilteredStatus
} = productionBatchSlice.actions;

export default productionBatchSlice.reducer;